module.exports = __webpack_public_path__ + "static/media/img-feature-company-200@3x.bed78309.png";